import {
  ClearOutlined,
  CloseCircleOutlined,
  CloudDownloadOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Layout,
  Modal,
  Row,
  Select,
  Tooltip,
} from "antd";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory, useLocation } from "react-router-dom";
import ApiMachine from "../../api/backend/machineManagement";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";
import CommonFilterTable from "../../component/table/TableFiltter";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  MODE_SCREEN,
} from "../../constants/common.const";
import {
  getQuerySearch,
  handleCatchError,
  MSG_CATCH,
  pushObject2Query,
  showMessage,
} from "../../constants/utils";
import classText from "../../models/control/text";
import { checkRoleScreen } from "../../utils/roles";
import ExcelJS from "exceljs";

import "./index.css";
import { formatNumber, formatNumberFloat } from "../../utils/helper";
import { resetEdits, updateCell } from "../../redux/ledger";
const { Content } = Layout;
const { Option } = Select;

let objSearchOrigin = {
  machineName: null,
  facilityName: null,
  isDowload: false,
};
let objSearch = { ...objSearchOrigin };
objSearch = getQuerySearch();
export const statusRes = (res) => {
  let data = {
    success: false,
    msg: "",
  };
  // Case success
  switch (res.status) {
    case 200:
      data.success = true;
      break;
    case 400:
      data.success = false;
      break;
    case 401:
      data.success = false;
      break;
    default:
      data.success = false;
      break;
  }

  return data.success;
};
const EditableCell = React.memo(
  ({ defaultValue = "", keyInput, recordKey }) => {
    const dispatch = useDispatch();
   const {edits} = useSelector(state => state.ledger)
    const value = (edits && edits[recordKey] && edits[recordKey].hasOwnProperty(keyInput)) ? edits[recordKey][keyInput] : defaultValue
    const handleChange = function (e) {
      dispatch(updateCell({ id: recordKey, colKey: keyInput, value: e.target.value }));
    };

    return <Input value={value} onChange={handleChange} />;
  }
);
function LedgerDevices() {
  const {edits} = useSelector(state => state.ledger)
  const dispatch = useDispatch()
  const [formSearch] = Form.useForm();
  const isPC = useMediaQuery({ query: KEY.LAPTOP_WIDTH });
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [showLoading, setShowLoading] = useState(false);

  const [grid, setGrid] = useState({ data: [], keepFilterSort: false });
  const [gridEdit, setGridEdit] = useState([]);
  // Input Search
  const [txtMachine, setTxtMachine] = useState(
    new classText(objSearch.machineName || "")
  );
  const [txtFacilityName, setTxtFacilityName] = useState(
    new classText(objSearch.facilityName || "")
  );
  const [heightSub, setHeightSub] = useState(0);
  const { listDataTable, listColumn } = useSelector((state) => state.ledger);

  const syncInput = (init = true, defaultValue) => {
    objSearch.machineName = defaultValue
      ? defaultValue.machineName
      : txtMachine.value
      ? txtMachine.value.trim()
      : null;
    objSearch.facilityName = defaultValue
      ? defaultValue.facilityName
      : txtFacilityName.value
      ? txtFacilityName.value.trim()
      : null;
    // Push to url
    pushObject2Query({
      ...objSearch,
    });
  };
  const editMode = mode === MODE_SCREEN.EDIT;

  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);
    setGrid({
      ...grid,
      data: JSON.parse(JSON.stringify(originalGrid)),
      keepFilterSort: true,
    });
  };
  const handleCancel = () => {
    let isFillData = false;
    dispatch(resetEdits())
    const keysInput = [
      "priorityLevel",
      "overallCondition",
      "functionalityCondition",
      "physicalCondition",
      "auxiliaryEquipmentCondition",
    ];
    for (let i = 0; i < gridEdit.length; i++) {
      let row = gridEdit[i];
      const currentCode = row.machineForSiteOfficeCode;
      let rowOrigin = originalGrid.find(
        (or) => or.machineForSiteOfficeCode == currentCode
      );
      if (!rowOrigin) {
        continue;
      }
      for (let key = 0; key < keysInput.length; key++) {
        const currentKey = keysInput[key];
        if (row[currentKey] != rowOrigin[currentKey]) {
          isFillData = true;
          break;
        }
      }
      if (isFillData) {
        break;
      }
    }
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  const handleEdit = () => {
    setMode(MODE_SCREEN.EDIT);
    setGridEdit(JSON.parse(JSON.stringify(grid.data)));
    dispatch(resetEdits())
  };

  const [originalGrid, setOriginalGrid] = useState([]);
  const handleSave = () => {
    Modal.confirm({
      centered: true,
      title: lang.CONFIRM,
      content: COMMON_CONSTANT.BOM_C009,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,
      onOk: () => {
        const keysInput = [
          "priorityLevel",
          "overallCondition",
          "functionalityCondition",
          "physicalCondition",
          "auxiliaryEquipmentCondition",
        ];
        const updatedRows = [];

        Object.keys(edits).forEach(key => {
          const updateItem = grid.data.find(i => i.machineForSiteOfficeCode == key);
          if(updateItem){
            updatedRows.push({
              ...updateItem,
              ...edits[key]
            })
          }
        })
        setShowLoading(true);
        ApiMachine.UpdateMultiMachine(updatedRows)
          .then(() => {
            showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003);
            setMode(MODE_SCREEN.VIEW);
            search_onClick();
            dispatch(resetEdits())
          })
          .catch((error) => {
           handleCatchError()
          })
          .finally(() => {
            setShowLoading(false);
          });
      },
      onCancel: () => {},
    });
  };
  const clearInputSearch = () => {
    formSearch.resetFields();
    setTxtFacilityName({
      ...txtFacilityName,
      value: "",
    });
    setTxtMachine({
      ...txtMachine,
      value: "",
    });
    search_onClick(false,{
      machineName:"",
      facilityName:""
    })
  };
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };
  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const showMessageError = (msg) => {
    showMessage(KEY.ERROR, msg);
  };
  const search_onClick = (init, defaultValue, keepFilterSort) => {
    setMode(MODE_SCREEN.VIEW);
    // Loading
    openLoadingSpinner();

    // input to objectSearch; push url
    syncInput(init, defaultValue);
    objSearch.isDowload = false;
    // Update format
    objSearch = getQuerySearch();
    // Call
    return ApiMachine.searchNewMachine({
      params: {
        ...objSearch,
      },
    })
      .then((res) => {
        let resultData = Array.isArray(res.data.data) ? res.data.data : [];
        resultData = resultData.map((record) => {
          const elapsedYears = Number(record.elapsedYears) || 0;
          const targetTime = Number(record.targetUsefulLife) || 0;
          const targetServiceLife = elapsedYears - targetTime;
          const situation = record.situation || "";
          const year = getYearFromValue(record.depreciationStart);
          let situationValue = "";
          if (situation) {
            const siItem = lang.MACHINE_STATUS_VALUE.find(
              (i) => i.key == situation
            );
            if (siItem) {
              situationValue = siItem.value;
            }
          }

          return {
            ...record,
            targetServiceLife,
            situation: situationValue,
            depreciationStart: year,
          };
        });

        const gridData = {
          data: resultData,
          keepFilterSort: keepFilterSort || false,
        };
        setGrid(gridData);
        setOriginalGrid(JSON.parse(JSON.stringify(gridData.data)));
      })
      .catch((error) => {
        handleCatchError()
      })
      .then(() => {
        // Close loading
        closeLoadingSpinner();
      });
  };

  const tablekey = "ledger";
  const disabledDowload =
    !listDataTable[tablekey] ||
    !listColumn[tablekey] ||
    !Array.isArray(listDataTable[tablekey]) ||
    !Array.isArray(listColumn[tablekey]) ||
    listColumn[tablekey].length == 0 ||
    listDataTable[tablekey].length == 0;

  const onDownloadSingleFile = async () => {
    if (disabledDowload) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    const headerColumns = columns.filter((i) =>
      listColumn[tablekey].includes(i.dataIndex)
    );
    const headers = headerColumns.map((i) => i.title);
    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(1);
    headerRow.height = 24;
    headerRow.eachCell((cell, colNumber) => {
      cell.font = { bold: true, size: 11 };
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "B4C6E7" },
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
    const data = listDataTable[tablekey];
    data.forEach((item, idx) => {
      const rowData = headerColumns.map((col) => {
        let value = item[col.dataIndex];
        if (value === 0) {
          return value;
        }

        if (col.dataIndex === "price" && value != null && value !== "") {
          value =
            Number(value) % 1 === 0
              ? Number(value).toLocaleString()
              : Number(value).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                });
        }

        if (
          col.dataIndex === "enginePowerOutput" &&
          value != null &&
          value !== ""
        ) {
          value = Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          });
        }

        return value || "";
      });

      const row = worksheet.addRow(rowData);
      row.height = 20;

      row.eachCell((cell, colNumber) => {
        let align = headerColumns[colNumber - 1].align || "left";
        cell.alignment = { vertical: "middle", horizontal: align };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    const columnWidths = [
      24, 24, 24, 24, 24, 24, 24, 24, 24, 10, 10, 14, 14, 18, 15, 14, 10, 18,
      18, 18, 18, 18, 18, 15, 15, 15, 18, 15, 13,
    ];

    worksheet.columns.forEach((col, i) => {
      col.width = columnWidths[i] || 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    const formattedDate = moment().format("YYYYMMDDHHmmss");
    link.target = "_blank";
    const fileName = "機器一覧_" + formattedDate;
    link.download = fileName + ".xlsx";
    link.click();
  };

  const renderTextCell = (text, align) => {
    const displayText =
      text && text.length > 20 ? `${text.slice(0, 20)}...` : text;
    return (
      <Tooltip title={text}>
        <div style={{ textAlign: align || "center" }}>{displayText}</div>
      </Tooltip>
    );
  };
  const renderColumnTitle = (title) => (
    <span>
      <span> {title}</span>
    </span>
  );

  const getDefaultvalue = (key, machineCode) => {
    const item = gridEdit.find(
      (i) => i.machineForSiteOfficeCode == machineCode
    );
    if (item) {
      return item[key];
    }
    return "";
  };
  function getYearFromValue(value) {
    if (!value) return "";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "";

    return date.getFullYear().toString();
  }
  const renderText = (text) => (
    <Tooltip title={text}>
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
  const columns = [
    {
      title: "管理番号",
      dataIndex: "machineForSiteOfficeCode",
      align: "left",
      ellipsis: true,
      width: 210,
      render: renderText,
    },

    {
      title: "施設",
      dataIndex: "facilityName",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "設備",
      dataIndex: "machineForSiteOfficeName",
      align: "left",
      width: 230,
      render: (text, record) => {
        const displayText =
          text && text.length > 20 ? `${text.slice(0, 20)}...` : text;
        return (
          <Tooltip title={text}>
            {editMode ? (
              <div style={{ textAlign: "left" }}>{displayText}</div>
            ) : (
              <a
                style={{ display: "block", textAlign: "left" }}
                href={`/FacilityEquipmentListInfo?code=${record.machineForSiteOfficeCode}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {displayText}
              </a>
            )}
          </Tooltip>
        );
      },
    },

    {
      title: "工種",
      dataIndex: "equipmentClassificationName",
      align: "left",
      width: 230,
      render: (text) => {
        const displayText =
          text && text.length > 20 ? `${text.slice(0, 20)}...` : text;
        return (
          <Tooltip title={text}>
            <div style={{ textAlign: "left" }}>{displayText}</div>
          </Tooltip>
        );
      },
    },
    {
      title: "設備大分類",
      dataIndex: "equipmentHigher",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "設備中分類",
      dataIndex: "equipmentMiddle",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "設備小分類",
      dataIndex: "equipmentMinor",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "設置場所",
      dataIndex: "parentInstallLocationName",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "詳細位置",
      dataIndex: "installLocationName",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "取得年度",
      dataIndex: "depreciationStart",
      align: "center",
      width: 150,
      type: "number",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "経過年数",
      dataIndex: "elapsedYears",
      align: "center",
      width: 150,
      type: "number",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "標準耐用年数",
      dataIndex: "standardUsefulLife",
      align: "center",
      width: 150,
      type: "number",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "目標耐用年数",
      dataIndex: "targetUsefulLife",
      align: "center",
      width: 150,
      type: "number",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "目標耐用年数超過年数",
      dataIndex: "targetServiceLife",
      align: "center",
      width: 200,
      type: "number",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "取得価格",
      dataIndex: "price",
      align: "right",
      width: 150,
      type: "number",
      render: (text, record) => {
        return <div style={{ textAlign: "right" }}>{formatNumber(text)}</div>;
      },
    },
    {
      title: "管理方法",
      dataIndex: "managementMethodValue",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "状態",
      dataIndex: "situation",
      align: "center",
      width: 150,
      render: renderText,
    },
    {
      title: "優先度（リスクの評価）",
      dataIndex: "priorityLevel",
      align: "left",
      width: 230,
      render: (text, record) =>
        mode === MODE_SCREEN.EDIT ? (
          <EditableCell
            keyInput="priorityLevel"
            recordKey={record.machineForSiteOfficeCode}
            defaultValue={record.priorityLevel}
          />
        ) : (
          renderTextCell(text, "left")
        ),
    },
    {
      title: "重要度（影響度）",
      dataIndex: "importanceLevel",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "機器状態（総合）",
      dataIndex: "overallCondition",
      align: "left",
      width: 230,
      render: (text, record) =>
        mode === MODE_SCREEN.EDIT ? (
          <EditableCell
          keyInput="overallCondition"
          recordKey={record.machineForSiteOfficeCode}
          defaultValue={record.overallCondition}
        />
        ) : (
          renderTextCell(text, "left")
        ),
    },
    {
      title: "機器状態（機能）",
      dataIndex: "functionalityCondition",
      align: "left",
      width: 230,
      render: (text, record) =>
        mode === MODE_SCREEN.EDIT ? (
          <EditableCell
          keyInput="functionalityCondition"
          recordKey={record.machineForSiteOfficeCode}
          defaultValue={record.functionalityCondition}
        />
        ) : (
          renderTextCell(text, "left")
        ),
    },
    {
      title: "機器状態（物理的）",
      dataIndex: "physicalCondition",
      align: "left",
      width: 230,
      render: (text, record) =>
        mode === MODE_SCREEN.EDIT ? (
          <EditableCell
          keyInput="physicalCondition"
          recordKey={record.machineForSiteOfficeCode}
          defaultValue={record.physicalCondition}
        />
        ) : (
          renderTextCell(text, "left")
        ),
    },
    {
      title: "機器状態（補機）",
      dataIndex: "auxiliaryEquipmentCondition",
      align: "left",
      width: 230,
      render: (text, record) =>
        mode === MODE_SCREEN.EDIT ? (
          <EditableCell
          keyInput="auxiliaryEquipmentCondition"
          recordKey={record.machineForSiteOfficeCode}
          defaultValue={record.auxiliaryEquipmentCondition}
        />
        ) : (
          renderTextCell(text, "left")
        ),
    },
    {
      title: "仕様　型式",
      dataIndex: "modelNumber",
      align: "left",
      width: 150,
      render: (text, record) => {
        return renderTextCell(text, "left");
      },
    },
    {
      title: "仕様　型番",
      dataIndex: "partNumber",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "仕様　メーカー",
      dataIndex: "manufactureName",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "仕様　寸法",
      dataIndex: "dimensions",
      align: "left",
      width: 150,
      render: renderText,
    },
    {
      title: "仕様　能力",
      dataIndex: "capacity",
      align: "left",
      width: 200,
      render: renderText,
    },
    {
      title: "電動機出力",
      dataIndex: "enginePowerOutput",
      align: "right",
      width: 230,
      type: "number",
      render: (value, record) => {
        if (value != null && value !== "") {
          return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          });
        }
        return "";
      },
    },
  ];
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  useEffect(() => {
    const element = document.getElementById("search-equipment-id");
    if (element) {
      const subHeight = element.offsetHeight;
      setHeightSub(subHeight);
    }
  }, []);

useEffect(() => {
return () => {
  dispatch(resetEdits())
}
},[])

  useEffect(() => {
    search_onClick();
  }, []);

  const colFinal = useMemo(() => {
    return columns;
  }, [editMode, mode, gridEdit]);
  return (
    <div className="des-content">
      <TitlePage name={"機器一覧"} />
      <div id={"search-equipment-id"}>
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
          }}
        >
          <Form
            layout={"vertical"}
            name="searchCL"
            className="formStyle"
            form={formSearch}
          >
            <div>
              <Row gutter={[8, isPC ? 0 : 16]}>
                <Col span={isPC ? 5 : 24}>
                  <Input
                    disabled={editMode}
                    placeholder="施設"
                    value={txtFacilityName.value}
                    maxLength={255}
                    onChange={(e) =>
                      setTxtFacilityName({
                        ...txtFacilityName,
                        value: e.target.value,
                      })
                    }
                    allowClear
                  />
                </Col>
                <Col span={isPC ? 5 : 24}>
                  <Input
                    disabled={editMode}
                    placeholder="設備"
                    value={txtMachine.value}
                    maxLength={255}
                    onChange={(e) =>
                      setTxtMachine({
                        ...txtMachine,
                        value: e.target.value,
                      })
                    }
                    allowClear
                  />
                </Col>

                <Col span={isPC ? 14 : 24}>
                  <Button
                    disabled={editMode}
                    className="buttonPC button--info wAuto ml10"
                    htmlType="submit"
                    onClick={() => search_onClick()}
                  >
                    <SearchOutlined /> {lang.SEARCH}
                  </Button>

                  <Button
                    disabled={editMode}
                    className="buttonPC button--outline --todo-- wAuto ml10"
                    onClick={clearInputSearch}
                  >
                    <ClearOutlined /> 条件クリア
                  </Button>
                  <Button
                    className="buttonPC button--outline --todo-- wAuto ml10"
                    disabled={mode === MODE_SCREEN.EDIT || disabledDowload}
                    onClick={(e) => {
                      onDownloadSingleFile();
                    }}
                  >
                    <CloudDownloadOutlined style={{ color: "#f50" }} />{" "}
                    {lang.EXPORT}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Content>
      </div>
      <Content
        className={isPC && "site-layout-background"}
        style={{ padding: isPC ? 24 : 0 }}
      >
        <CommonFilterTable
          paging={true}
          isLeft={false}
          rowKey={useCallback((record) => record.assetManagementNumber, [])}
          // className="gridSingle"
          className="table-equipment-custome my-custom-table"
          columns={colFinal}
          data={grid.data}
          // scrollX={"max-content"}
          keepFilterSort={grid.keepFilterSort}
          scrollY={`calc(100vh - ${heightSub + 24 * 2 + 35 + 45 + 60 + 140}px)`}
          color={"#ffffff"}
          tableKey="ledger"
        />
      </Content>
      <FooterPage>
        {mode !== MODE_SCREEN.ADD && mode !== MODE_SCREEN.EDIT ? (
          <Row justify="end">
            <Col>
              <Button
                disabled={grid.data.length === 0}
                onClick={handleEdit}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <EditOutlined /> {lang.EDIT}
              </Button>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="end">
              <Col>
                <Button
                  onClick={handleSave}
                  className="buttonPC button--info wAuto ml10"
                >
                  <SaveOutlined /> {lang.SAVE}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={handleCancel}
                  className="buttonPC button--outline --todo-- wAuto ml15"
                >
                  <CloseCircleOutlined /> {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </FooterPage>
      <Loading show={showLoading} />
    </div>
  );
}

export default LedgerDevices;
